import { customRecurrenceModalTitle } from './CustomRecurrenceModal.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import CustomRecurrenceFooter from './CustomRecurrenceFooter';
import CustomRecurrenceModalBody from './CustomRecurrenceModalBody';
import CustomRecurrenceModalHeader from './CustomRecurrenceModalHeader';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';

import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { OwaDate } from 'owa-datetime';
import { CalendarEvent } from 'owa-calendar-types';
import { FullComposeViewState } from 'owa-calendar-compose-types';
import { OwaModal } from 'owa-dialog';
import { observer } from 'mobx-react-lite';
import {
    hideCustomRecurrenceForm,
    updateCustomRecurrenceFormRecurrenceType,
    updateCustomRecurrenceFormStartDate,
    saveCustomRecurrence,
} from 'owa-calendar-compose-form-actions';

const styles = require('./CustomRecurrenceModal.scss');
let classNames = require('classnames/bind').bind(styles);

export interface CustomRecurrenceModalProps {
    event: CalendarEvent;
    colorScheme: ColorScheme;
}

const CustomRecurrenceModal = observer(function CustomRecurrenceModal(
    props: CustomRecurrenceModalProps
) {
    const fullComposeViewState: FullComposeViewState = getFullComposeViewState();
    let recurrence: RecurrenceType;
    let startDate: OwaDate;

    if (fullComposeViewState) {
        recurrence = fullComposeViewState.customRecurrenceViewState.recurrence;
        startDate = fullComposeViewState.customRecurrenceViewState.startDate;
    }
    const showModal: boolean = !!(recurrence && startDate);

    if (!showModal) {
        return null;
    }

    return (
        <OwaModal
            className={styles.dialog}
            isOpen={true}
            isBlocking={false}
            onDismiss={hideCustomRecurrenceForm}>
            <div className={classNames(styles.customRecurrenceContainer)}>
                <CustomRecurrenceModalHeader
                    onClose={hideCustomRecurrenceForm}
                    text={loc(customRecurrenceModalTitle)}
                />
                <CustomRecurrenceModalBody
                    event={props.event}
                    recurrence={recurrence}
                    startDate={startDate}
                    colorScheme={props.colorScheme}
                    onRecurrenceChangedCallback={updateCustomRecurrenceFormRecurrenceType}
                    onStartDateChangedCallback={updateCustomRecurrenceFormStartDate}
                />
                <CustomRecurrenceFooter
                    colorScheme={props.colorScheme}
                    onDiscard={hideCustomRecurrenceForm}
                    onSave={saveCustomRecurrence}
                />
            </div>
        </OwaModal>
    );
});

export default CustomRecurrenceModal;
